<div class="admin-page-container">

  <admin-toolbar class="admin-toolbar" (toggleSidebar)="toggleSidebar()" section="General"></admin-toolbar>

  <mat-sidenav-container id="admin-content-wrapper" class="admin-content-wrapper">

    <mat-sidenav #adminsidenav class="admin-sidebar">

      <admin-sidebar></admin-sidebar>

    </mat-sidenav>

    <mat-sidenav-content>

      <!-- [START] page content -->

      <mat-card style="width: 100%; display: block;">

        <mat-card-header>
          <mat-card-title>Users</mat-card-title>
        </mat-card-header>

        <mat-card-content>

          <mat-grid-list cols="3" >

            <mat-grid-tile>
              <a [class]="'main-admin-action-list-item'" mat-list-item [routerLink]="['/administration/users/pending']"><img src="assets/images/approve-user.png" width="120"></a>
              <div>
                <label>Pending: {{pendingCount}}</label>
              </div>
            </mat-grid-tile>

            <mat-grid-tile>
              <a [class]="'main-admin-action-list-item'" mat-list-item [routerLink]="['/administration/users']"><img src="assets/images/manage-users.png" width="120"></a>
              <div>
                <label>Users: {{userCount}}</label>
              </div>
            </mat-grid-tile>

            <mat-grid-tile>
              <a [class]="'main-admin-action-list-item'" mat-list-item [routerLink]="['/administration/users/new']"><img src="assets/images/create-user.png" width="120"></a>
            </mat-grid-tile>

          </mat-grid-list>

        </mat-card-content>
      </mat-card>


      <mat-card style="width: 100%; height: 250px; display: block;">

        <mat-card-header>
          <mat-card-title>Blob Manager</mat-card-title>
        </mat-card-header>

        <mat-card-content style="display: block; height: 200px;">

          <mat-grid-list cols="2" rowHeight="fit" style="display: block; height: 200px;">

            <mat-grid-tile>

              <table>
                <tr><th colspan="2">Metrics</th></tr>
                <tr><td></td><td></td></tr>
                <tr><td style="text-align: right; padding-right: 8px;">Users: </td><td>{{userCount}}</td></tr>
                <tr><td style="text-align: right; padding-right: 8px;">Blobs: </td><td>{{totalFiles}}</td></tr>
                <tr><td style="text-align: right; padding-right: 8px;">Size: </td><td>{{totalBytes}}</td></tr>
                <tr><td style="text-align: right; padding-right: 8px;">DB Size: </td><td>{{dbSize}}</td></tr>
              </table>

            </mat-grid-tile>

            <mat-grid-tile>

              <label> {{blobDiskUsed}} / {{blobDiskSize}}</label>
              <p-knob
                readonly="true"
                [(ngModel)]="blobDiskPercent"
                [size]="180"
                [min]="0"
                [max]="100"
                valueTemplate="{value}%"
                textColor="white"
                [valueColor]="strokeColor">

              </p-knob>

            </mat-grid-tile>

          </mat-grid-list>

        </mat-card-content>

      </mat-card>

      <!-- [END] page content -->

      <admin-footer  section="Users"></admin-footer>

    </mat-sidenav-content>

  </mat-sidenav-container>

</div>

